export default __webpack_public_path__ + "static/media/image-fisheye.ff97b54e.jpg";